import styled, { css } from "styled-components";

export const ContainerStyledWrapper = styled.div``;

export const StyledForm = styled.form`
  margin-top: 32px;
  ${({ $withoutAccordion }) =>
    !$withoutAccordion &&
    css`
      background: ${({ theme }) => theme.colors.primaryLightFill};
    `};

  > hr {
    margin-left: 40px;
    margin-right: calc(100% - 749px);
    border-color: ${({ theme }) => theme.colors.primaryRulerTint50};
  }
`;

export const AccordionContent = styled.div`
  padding: 50px 40px;
  padding-right: 315px;

  ${({ $dark }) =>
    $dark &&
    css`
      background-color: ${({ theme }) => theme.colors.primaryLightFill};
    `}

  ${({ $error }) =>
    $error &&
    css`
      background-color: ${({ theme }) => theme.colors.offTrackBackground20};
      margin-bottom: -32px;
      margin-top: 32px;

      > h6 {
        color: ${({ theme }) => theme.colors.neutralsText};
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.18px;
        margin: 6px 0 16px;
        word-break: break-word;
        white-space: break-spaces;
      }
    `}

  &.button-container {
    padding-top: 32px;
    display: flex;
    justify-content: flex-end;
    ${({ $withoutAccordion }) =>
      $withoutAccordion &&
      css`
        padding-right: 40px;
      `};

    > button {
      font-weight: 500;
      padding: 24px;
    }
  }
`;
